import React from 'react'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import { Alert } from '@carsys/ui'
import { Grid } from '@mui/material'

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      cursor: 'default'
    }
  })
)

export const NoResults: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const classes = useStyles()

  return (
    <Grid item xs={12} className={classes.root}>
      <Alert color='muted'>{children}</Alert>
    </Grid>
  )
}
